<template>
  <div class="item sc-gKsewC gnwqMi" @click="detalhes()" style="max-width: 100%">
    <div class="col ">
      <div class="info">
        <strong class="name">
          <!-- <span class="notify-badge cor-primaria-bg" v-if="produto.promocao == 'S' && produto.descricao_promocao == ''">Promoção</span><br><br> -->
          <span class="notify-badge cor-primaria-bg" v-if="produto.promocao == 'S' && (produto.descricao_promocao == null || produto.descricao_promocao == '')">Promoção</span>
          <span class="notify-badge cor-primaria-bg" v-if="produto.promocao == 'S' && (produto.descricao_promocao != null && produto.descricao_promocao != '')">{{produto.descricao_promocao}}</span>
          <br><br></br>
          {{produto.nome.toLocaleUpperCase()}}
        </strong>
        <p class="description" v-if="produto.descricao">{{ produto.descricao.length > 100  ? produto.descricao.slice(0,100) + '...' : produto.descricao }}</p>
        <!-- <p class="price" v-if="produto.valor != '0.00' ">R$ {{ produto.valor }}</p> -->
        <span v-if="produto.promocao == 'S'">
          <div class="action-wrap">
            <div class="price-wrap h5">
                <div class=" price-new" style="" v-if="produto.valor > 0">
                  <strong class="price"  v-if="produto.promocao == 'S'">R${{produto.valor_promocional}}</strong>
                  <strike style="font-size: 12px" v-if="produto.promocao == 'S' && this.$store.state.empresa.ocultar_preco_anterior != 'S'">R${{produto.valor}}</strike>
                </div>
                <div class=" price-new"  v-else style="color: #ffffff00;">
                  <strong style="font-size: small" >R$</strong>
                </div>
            </div>
          </div>
        </span>
        <span v-else>
          <p class="price" v-if="produto.valor != '0.00' ">R$ {{ produto.valor }}</p>
        </span>

      </div>
    </div>
    <div class="col s4" v-if="produto.foto" >
      <img v-lazy="produto.produto_imagem_preview"  class="responsive-img" data-loading="../../assets/loading.gif" >
    </div>
  </div>
</template>

<script>
  export default {
    name: "Item",
    props: ['produto', 'grupo'],
    methods:{
      detalhes(){
        this.produto.grupo_nome = this.grupo;

        if(this.produto.promocao == 'S'){
          let valor = this.produto.valor;
          let valor_promocional = this.produto.valor_promocional;
          this.produto.valor_real = valor;
          this.produto.valor = valor_promocional;
        }

        this.$store.commit('produto', this.produto);
        this.$router.push('/' + this.$store.state.empresa_url + '/menu/produto/' + this.produto.id)
      }
    }
  }
</script>

<style scoped>
  .item {
    width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    cursor: pointer;
    padding: 26px 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.03);
    /* background-color: #f9f9f9; */
  }
  .item .info {
    width: 100%;

  }
  .item .info .name {
    display: block;
    margin-bottom: 8px;
    line-height: 20px;
  }
  .item .info .description {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 17px;
    /* color: #7f8f9f; */
  }
  .item .info .price {
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
  }

  @media only screen and (max-device-width: 768px) {
    /* Styles */
    .item {
      padding: 19px 5px 5px 5px;
      border: 1px solid rgba(0, 0, 0, 0.07);
    }
  }

  .itemb {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: start;
    align-items: start;
  }

  .itemb .titulo-item {
    line-height: 2;
    font-size: 1.2rem;
    margin-bottom: 8px;
  }

  .itemb .titulo-descricao {
    line-height: 2;
    font-size: 0.90rem;
    margin-bottom: 8px;
  }

  .itemb .titulo-valor {
    line-height: 2;
    font-size: 1.2rem;
    margin-bottom: 8px;
  }



  .gnwqMi {
    width: 100%;
    padding: 20px 16px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    cursor: pointer;
  }

  .gnwqMi .info {
    width: 100%;
  }

  .gnwqMi .info .name {
    margin-bottom: 10px;
    display: block;
    font-size: 16px;
    line-height: 120%;
    font-weight: 700;
  }

  .gnwqMi img {
    max-width: 84px;
    min-width: 84px;
    max-height: 84px;
    min-height: 84px;
    margin-left: 10px;
    border-radius: 4px;
    background: rgb(196, 196, 196);
    object-fit: cover;
  }

  .gnwqMi:hover {
    /* background-color: rgb(250, 250, 250); */
    background-color: rgba(128, 128, 128, 0.1);
  }
  .gnwqMi .info .description {
    margin-bottom: 5px;
    /* color: rgb(127, 143, 159); */
    /*font-size: 12px;*/
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    word-break: break-word;
  }

  .gnwqMi .info {
    width: 100%;
  }


  .notify-badge{
    background: #8b0000bf;
    text-align: center;
    border-radius: 20px 20px 20px 20px;
    color: white;
    padding: 5px 5px;
    z-index: 9;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Widgets/Item.vue